export enum HeaderEnum {
  animationDelay = 800
}
